<template>
    <div
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 font-medium text-white dark:text-gray-900 bg-gray-900 rounded-lg opacity-0 tooltip dark:bg-gray-300 text-md transition-opacity shadow-white dark:shadow-gray-700 border-2 border-white dark:border-none shadow-lg">
        <slot>Tooltip</slot>
        <div class="tooltip-arrow" data-popper-arrow></div>
    </div>
</template>
